"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _SubscriptionLabel = require("./SubscriptionLabel");
Object.keys(_SubscriptionLabel).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SubscriptionLabel[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _SubscriptionLabel[key];
    }
  });
});
